import React from "react";
import {useContext} from "react";
import useRole from "../hooks/useRole";
import config from "../../js/config_static";

import { Link, Navigate } from 'react-router-dom';
 
import "../../ui/css/general.css";
import "../css/buttons.css";
import "./GreetingWindow.css";
import "./Login.css";

import logoutUser from "../../js/utils/async/logoutUser";

import CredentialsContext from "../contexts/CredentialsContext";


export default function Logout(props) {
  const [role] = useRole();
  // const onSubmit = props.onSubmit || () => 
  const redirect = props.redirect || "/login";

  const {credentials, setCredentials} = useContext(CredentialsContext);
  const userRoleTranslate = {
    user: "пользователь",
    expert: "эксперт",
    developer: "разработчик",
    admin: "администратор",
  }
  // const {credentials, setCredentials} = useCredentials()

  const handleSubmit = async e => {
    e.preventDefault();
    await logoutUser();
    localStorage.removeItem("jurinfortest");
    setCredentials();
    <Navigate to="/login"/>
  }

  if (!credentials) {
    return <Navigate to={redirect} />
  }

  return <div className="centering">
    <div className="loginpanel">
      <div className="title">{"Профиль"}</div>
      <form id="login" onSubmit={handleSubmit}>
        <div>{"Вы вошли как: " + credentials?.name}</div>
        {role ? <div>{"Ваша роль: " + userRoleTranslate[role]}</div> : false}
        <div className="flex-btn">
          {props.backMode ? <Link to={props.backMode} className="btn btn-success btn-default">Вернуться назад</Link> : false}
          <input type="submit" className="btn btn-success" value="Выйти"/>
        </div>
      </form>
    </div>
    {/* <div className="logininfo">{config.ui.Login.info}</div> */}
  </div>
}